import { Avatar, Tooltip } from "@mui/material"
import PersonIcon from '@mui/icons-material/Person';
import PeopleIcon from '@mui/icons-material/People';
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import { stringAvatar } from '../Utils';
import { CLIENT_ID } from "../Constants";

export default function UserAvatar({ user, tooltip, sx = {} }) {
    // cut off (Technician) or (me) from name if it exists
    let name = (user?.name || '').trim()
    if (name.endsWith(' (Technician)')) {
        name = name.slice(0, -13)
    } else if (name.endsWith(' (me)')) {
        name = name.slice(0, -4)
    }
    let src = null
    let my_sx = stringAvatar(name).sx
    let content = <PersonIcon />
    if (user?.id === 'CUSTOMER') {
        content = <PeopleIcon />
        my_sx = stringAvatar('').sx
    } else if (user === undefined || user === null) {
        content = <QuestionMarkIcon />
    } else if (user?.name && user?.id !== -1) {
        content = stringAvatar(name).children
    }
    if (user?.image_path) {
        src = `/customerimages/client/${CLIENT_ID}/users/${user.id}/${user.image_path}?update=${user.date_updated}`
        my_sx = {}
    } else if (user?.id === -1) {
        my_sx = stringAvatar('').sx
    }

    return (
        <Tooltip title={tooltip}>
            <Avatar
                src={src}
                sx={{ ...sx, ...my_sx }}
            >
                {content}
            </Avatar>
        </Tooltip >)
}